import React, { useEffect, useState } from 'react'
import { HeaderTable } from '../../HeaderTable'
import DataTable from 'react-data-table-component'
import axios from 'axios'
import { convertToIsraelTime, formatOnlyTime } from '../../../util/formatsForDate'
import NewAddItemForPurchase_archive from './NewAddItemForPurchase_archive'
import { BsPencil } from "react-icons/bs";
import { IoTrashOutline } from "react-icons/io5";
import ModalEdit from '../../ModalEdit';
import EditAddItemForPurchase_archive from './EditAddItemForPurchase_archive'

const Purchase_archive = ({ row }) => {
    const [id, setId] = useState("");
    const [modalIsOpen, setModalIsOpen] = useState("");
    const [fetchData, setFetchData] = useState([])
    const [loading, setloading] = useState(true)
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1)
    const GET_DELETE = 'admin/setting/paying_customer/transaction'
    const GET_URL = `admin/setting/paying_customer/transaction/${row?.id}`
    const URL_EXCLE = `admin/setting/paying_customer/transaction_excel/${row?.id}`


    const getDataTable = async (page) => {
        setloading(true)
        await axios.get(GET_URL, {
            params: {
                "page": page
                , "size": perPage,
            }
        })
            .then(response => {
                if (response.status == 200) {
                    setFetchData(response?.data?.transactionPayCustomerDto)
                    // setdataForfilterScrach(response?.data)
                    setTotalRows(response.data.totalElements);
                }
            })
        setloading(false)

    }




    const handlePerRowsChange = async (newPerPage) => {
        setPerPage(newPerPage);

    }

    // const handleChange = (e) => {
    //     const { name, value } = e.target;
    //     setDataFillter({
    //         ...dataFillter,
    //         [name]: value
    //     });
    // }
    const handlePageChange = (page) => {
        // fetchUsers(page);
        // getData(page);
        setCurrentPage(page);
    };
    useEffect(() => {
        getDataTable(currentPage - 1)
    }, [])


    const columns = [
{  name: "פעולות",

    cell: row => <div className='flex'>
             
      
        <button title="מחיקה" className=' border border-gray-500 ml-1 p-1 opacity-15 hover:opacity-100' onClick={() => {
            setId(row)
            setModalIsOpen("Delete")
        }}><IoTrashOutline/></button> 
        
        <button className=' border border-gray-500 ml-1 p-1 opacity-15 hover:opacity-100' onClick={() => {
        // setnamecalss(row?.description)
        // setAction("edit")
        setId(row)
        setModalIsOpen("Edit")
    }
    }><BsPencil /></button>
        </div>,
        style: {
                    fontSize: '10px',
                    justifyContent: 'center',
    
                    // width: '100px'
                },}
        ,
      

        {
            name: "הערות",
            grow: 1,
            selector: (row) => <div className=''
                style={
                    {
                        // padding:"auto",
                       
                        direction:"rtl",
                        whiteSpace: "normal",
                        // flexWrap:"wrap",
                        overflow: "hidden",
                    }
                }
            >{row?.note}</div>,
            style: {
                fontSize: '10px',
                justifyContent: 'center',
                
                // width: '100px'
            },
             


        },
        {
            name: "מספר קבלה",
            // grow: 3,
            cell: (row) => row?.transactionId,
            style: {
                fontSize: '10px',
                justifyContent: 'center',
                // width: '100px'
            },
             
        },
        // ארז אמר מיותר
        // {
        //     name: "מספר חשבונית",
        //     cell: row => row?.transactionId,

        //     style: {
        //         fontSize: '10px',
        //         justifyContent: 'center',

        //     },
        //     // grow: 3,


        // },

        {
            name: "סה\"כ לתשלום",
            cell: row => row?.amountPay,

            style: {
                fontSize: '10px',
                justifyContent: 'center',

            },
            // grow: 2,


        },
        {
            name: "כמות",
            // grow: 3,
            cell: (row) => row?.quantity,
            style: {
                fontSize: '10px',
                justifyContent: 'center',
                // width: '100px'
            },
             
        },
        {
            name: "מחיר ליחידה",
            // grow: 3,
            cell: (row) => row?.product?.price,
            style: {
                fontSize: '10px',
                justifyContent: 'center',
                // width: '100px'
            },
             
        },
        {
            name: "קוד מוצר",
            // grow: 3,
            cell: (row) => row?.product?.code,
            style: {
                fontSize: '10px',
                justifyContent: 'center',
                // width: '100px'
            },
             
        },
        {
            name: "שם מוצר",
            // grow: 3,
            cell: (row) => row?.product?.name,
            style: {
                fontSize: '10px',
                justifyContent: 'center',
                // width: '100px'
            },
             
        },
        {
            name: "שעה",
            // grow: 3,
            cell: (row) => formatOnlyTime(row?.datePayment),
            style: {
                fontSize: '10px',
                justifyContent: 'center',
                // width: '100px'
            },
             
        },
        {
            name: "תאריך",
            // grow: 3,
            cell: (row) => convertToIsraelTime(row?.datePayment),
            style: {
                fontSize: '10px',
                justifyContent: 'center',
                // width: '100px'
            },
             
        },




    ];



    const customStyles = {
        header: {
            style: {

                justifyContent: 'center',

            },
        },
        id: {
            style: {
                '&:2': { backgroundColor: '#EEEEEE' },
            }
        },
        headRow: {
            style: {
                justifyContent: 'center',
                borderTopStyle: 'solid',
                borderTopWidth: '1px',
                // borderTopColor: defaultThemes.default.divider.default,
            },
        },
        headCells: {
            style: {
                fontSize: '10px',
                justifyContent: 'center',
                borderRightStyle: 'solid',
                borderRightWidth: '1px',
                // borderRightColor: defaultThemes.default.divider.default,
                padding:"10px"
            },
        },
        cells: {
            style: {
                // '&:not(:last-of-type)': {
                // width:"50px",
                // height: '48px',
                // wordWrap: 'break-word', // Ensures the text wraps within the cell
                // whiteSpace: 'pre-wrap', // Maintains whitespace and line breaks
                borderRightStyle: 'solid',
                borderRightWidth: '1px',
                padding:"10px"

                // borderRightColor: defaultThemes.default.divider.default,
                // },
            },
        },
        rows: {
            style: {
                
                minHeight: '30px',
                backgroundColor: '#FFFFFF',
                '&:active': {
                    backgroundColor: '#EEEEEE',
                },
            },
        },
    }
    const handleDetele = async () => {
        console.log(`${GET_DELETE}/${id.id}`)
        await axios.delete(`${GET_DELETE}/${id.id}`).then(response => {
            
            if (response.status == 200) {
                handleColse()
                getDataTable(currentPage-1)
                // getDFilter()
                console.log("ok")
            }
            else {
                console.log("error")
            }
        })
    }
//  useEffect(() => {
//         if (modalIsOpen) {
//             document.body.style.overflow = 'hidden'; // Disable body scrolling
//           } else {
//             document.body.style.overflow = 'auto'; // Enable body scrolling
//           }
      
//           return () => {
//             document.body.style.overflow = 'auto'; // Cleanup: ensure body scroll is reset
//           };
//         // setHide(modalIsOpen)
//     }, [modalIsOpen])

    const downloadExcel = async () => {
        try {
            const response = await axios.get(URL_EXCLE, {
                // params: {
                //     ...dataFillter
                //   // member_number:"0001"
                // },
                responseType: 'blob', // הגדרת התגובה כ-blob לצורך הורדת הקובץ
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'report.xlsx');
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error('Error downloading file:', error);
        }

    }


    const handleColse = () => {
        setModalIsOpen("")
      }


    return (
        <div className='w-full p-3 ' style={{ direction: "ltr" }}>

            <HeaderTable active={"ארכיון רכישות"} downloadExcel={downloadExcel} setModalIsOpen={setModalIsOpen} ></HeaderTable>

            <DataTable columns={columns} data={fetchData} pagination
                customStyles={customStyles}
                paginationServer
                paginationTotalRows={totalRows}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
                progressPending={loading} className='border'
                // style={{width: "50%;",
                //     maxWidth: "70%",
                //     overflowX: "auto"  
                //     }} 
                    >
                
            </DataTable>
            {modalIsOpen == "New" && <NewAddItemForPurchase_archive showModal={modalIsOpen == "New"} handleColse={handleColse} getDataTable={getDataTable} row={row}/>}
            {modalIsOpen == "Edit" && <EditAddItemForPurchase_archive showModal={modalIsOpen == "Edit"} handleColse={handleColse} getDataTable={getDataTable} row={id}/>}
            {modalIsOpen == "Delete" && <ModalEdit showModal={modalIsOpen == "Delete"} handleColse={handleColse} handleDetele={handleDetele}></ModalEdit>}


        </div>

    )
}


export default Purchase_archive